<template lang="pug">
	div
		<span class="progressTitle" :style="c_titleStyle">{{p_title}}</span>
		div(class="d-flex" style="flex-wrap: wrap;height:70px")
			div(v-for="(s,idx) in c_statuses" class="progress-step" style="top:20px;")
				<div v-if="idx<d_statusId||(idx==d_statusId&&idx==p_statuses.length-1)" :title="s.name" class="progress-circle completed"><sup style="top:1.5em;color:black;white-space:nowrap;">{{m_name(s)}}</sup></div>
				<div v-else-if="idx==d_statusId" :title="s.name"class="progress-circle inProgress"><sup style="top:1.5em;color:black;white-space:nowrap;">{{m_name(s)}}</sup></div>
				<div v-else :title="s.name" class="progress-circle"><sup style="top:1.5em;color:black;white-space:nowrap;">{{m_name(s)}}</sup></div>
				<div v-if="idx<p_statuses.length-1&&(idx==6||idx==12||idx==18)" style="width:60px;text-align:right;" class="continue-line" :class="idx<d_statusId?'green-class':null" >
					<sub v-if="d_statusId>idx"  class="continue-completed" style="bottom:-0.25em;right:-0.15em;">&#8626;</sub>
					<sub v-else class="continue-notStarted" style="bottom:-0.25em;right:-0.15em;">&#8626;</sub>
				</div>
				div(v-else-if="idx<p_statuses.length-1" class="progress-line" :class="idx<d_statusId?'green-class':null")
</template>
<script>
export default {
  name: "KTProgressStatus",
  props: {
	p_entity:String,
    p_statusId:Number,
	p_statuses:Object,
	p_title:String,
  },
  data() {
    return {
	d_statusId:null,
	};
	},
  mounted(){
			
			this.d_statusId=this.p_statuses.findIndex(s=>s.id==this.p_statusId);
			
  },
  computed:{
	c_statuses(){ return this.p_statuses;},
	c_titleStyle(){return this.p_entity=="oppr"?"top:30px":"top:45px;";},
  },
  methods:{
		m_name(s){return s.name.length>10?s.name.substring(0,9)+"..":s.name;}
  },
	watch:{
		p_statusId(nv){this.d_statusId=this.p_statuses.findIndex(s=>s.id==nv);},
	},
};
</script>
<style scoped>
.progress-container {
	display: flex;
	align-items: center;
	justify-content: center;
}
.progress-step {
	display: flex;
	align-items: center;
	position: relative;
	
}
.progress-circle {
	width: 20px;
	height: 20px;
	background-color: #ddd;
	border-radius: 50%;
	display: flex;
	justify-content:center;
	
}
.progress-line {
	width: 60px;
	height: 5px;
    background-color: #ddd;
}
.continue-line {
	width: 50px;
	height: 5px;
    background-color: #ddd;
}
.green-class {
    background-color: #4CAF50;
}
.completed {
	background-color: #4CAF50;     
	color: white;
}
.inProgress {
	background-color: #4CAF50;  
	color: white;
	justify-content:center;
}
.notStarted {
	color: white;
}
.completed::after {
	content: "✔";
	position: absolute;
	font-size: 15px;
	color: white;
}
.inProgress::after {
	content: "...";
	position: absolute;
	font-size: 20px;
	color: white;
	top: -0.1em;            
}
.progressTitle {
    position: relative;
    //top: 30px;
	color:#4fa4ff;
}
.continue-completed{
    font-size:35px;
	font-weight:bold;
	color: #4CAF50;
	width: 10px;
	height: 20px;
	justify-content:center;
}
.continue-notStarted{
    font-size:35px;
	font-weight:bold;
	width: 10px;
	height: 20px;
	color:#ddd;
	justify-content:center;
}
.continue-end{
	content:"&#8627";
    font-size:100px;
	color: #4CAF50;
}
</style>